<template>
  <div class="zutai-editor" v-if="showIframe">
    <!-- <iframe v-if="showIframe" ref="iframe" :src="graphEditorUrl" width="100%" height="100%" @load="setupIframe" frameborder="0" /> -->
    <iframe ref="iframe" :src="graphEditorUrl" width="100%" height="100%" frameborder="0" />
    <!-- <choose-date-dialog ref="datePicker" :visible.sync="dialogVisible" @confirm="onChooseDate" /> -->
  </div>
</template>
<script>
import website from '@/config/website'
import { getToken, removeToken, removeRefreshToken } from '@/utils/auth';
import { Base64 } from 'js-base64'
import { getStore } from 'utils/store';
import { graphEditorUrl, imageBaseUrl } from '@/config/env';
import { mapState } from 'vuex'
// import { detail as getViewDetail, update as updateView, list as getViewList } from '@/api/ml-link/view'
// import { page as getDeviceListPage, getDeviceItemInfos } from '@/api/ml-link/device'
// import { treelist as getDSTreeList, getItemInfosByRtuidcb as getDSList, getItemInfosByRtuidcbs } from '@/api/ml-link/datasource'
// import { getRtDataByItemIds } from '@/api/ml-link/itemrd'
import { remove, getTree, save, update, getDetail, setTop } from '@/api/assemble/tree';
import { getDataPageDetail, getPageList, savePage, updatePage, removePage } from '@/api/assemble/index';
import { getProjectTree } from '@/api/project/project';
import { eleJfpgReport, jfpgBarGraph, getEleJfpgData as getBigScreenInfo } from '@/api/energyManage/reportData';
import request from '@/axios';
import {
  getTreeList as getDSTreeList,
  getFourRemoteTypes as getDSList,
  getTimeTypes,
  getCompareTypes,
  getPointList,
  getHistoryData as getHistoryDataCurve,
  // getViewGroupTree,
  getImageList, addImage, removeImage } from '@/api/assemble/editor'
// import { getHistoryDataCurve, getHistoryDataSum, getHistoryDataItemsSum } from '@/api/ml-link/historyData'
// import { detail as getStationDetail, tree as getStationTree } from '@/api/ml-link/station'
// import { select as getAreaInfo } from '@/api/blade-system/region'
// import { startVideo } from '@/api/ml-link/camera'
// import ChooseDateDialog from './ChooseDateDialog.vue'
import { getPrimaryLanguage } from '@/lang/lang.js'

function mapStationTreeToList(treeData, parentName) {
  const CHILDREN = 'childAreaList'
  const NAME = 'areaName'
  const result = []

  treeData.forEach(data => {
    const chidren = data[CHILDREN]
    const item = { ...data, [CHILDREN]: undefined }
    if (parentName !== undefined) {
      item[NAME] = parentName + '-' + item[NAME]
    }
    result.push(item)
    if (chidren && chidren.length) {
      const childrenList = mapStationTreeToList(chidren, item[NAME])
      result.push(...childrenList)
    }
  })

  return result
}

export default {
  name: 'ZutaiEditor',
  components: {
    // ChooseDateDialog
  },
  data() {
    return {
      graphEditorUrl,
      view: undefined,
      showIframe: false,
      iWindow: undefined,
      stationTreeData: [],
      stationTreeList: [],
      timeOptions: [], // 时间类型
      compareOptions: [], // 对比类型
      viewList: [], // 组态页面列表
      dialogVisible: false,
      dialogCallback: undefined
    }
  },
  computed: {
    ...mapState({
      currentArea: state => state.station.currentArea
    })
  },
  mounted() {
    const zutaiId = this.$route.query.id;
    if (zutaiId) {
      // Promise.all([getDataPageDetail({ id: zutaiId }), getStationTree(), getViewGroup({})])
      Promise.all([
        getDataPageDetail({ id: zutaiId }),
        getProjectTree(),
        getTree(),
        getTimeTypes(),
        getCompareTypes(),
      ]).then(result => {
          let res = result[0];
          this.view = res.data.data;

          let projectTreeRes = result[1] // 项目树
          this.stationTreeData = projectTreeRes.data.data
          this.stationTreeList = mapStationTreeToList(this.stationTreeData)

          let typeTreeRes = result[2]; // 分组树
          const groupTree = typeTreeRes.data.data;

          let timeRes = result[3]
          const timeOptions = timeRes.data.data;getTimeTypes
          timeOptions.forEach(item => {
            item.label = item.i18nValue;
            item.value = item.dictKey;
          })
          this.timeOptions = timeOptions;

          let compareRes = result[4];
          const compareOptions = compareRes.data.data;
          compareOptions.forEach(item => {
            item.label = item.i18nValue;
            item.value = item.dictKey;
          })
          this.compareOptions = compareOptions;

          const { groupId } = this.view;
          // can only access same groupId views.
          getPageList({}).then(res => {
            const { data } = res.data
            const viewList = []
            // const viewList = res.data.data.map(view => ({ id: view.id, viewName: view.viewName, viewData: view.viewData }))
            const sortViewByGroup = (tree) => {
              tree.forEach(item => {
                const viewGroup = {
                  id: item.id,
                  groupName: item.title,
                  views: []
                }
                // groupId有可能是long型
                // eslint-disable-next-line eqeqeq
                viewGroup.views.push(...data.filter(view => view.groupId == item.id))
                if (viewGroup.views.length) { viewList.push(viewGroup) }
                if (item.children && item.children.length) {
                  sortViewByGroup(item.children)
                }
              })
            }
            sortViewByGroup(groupTree)
            this.viewList = viewList
            this.showIframe = true
            this.$nextTick(() => {
              this.iWindow = this.$refs['iframe'].contentWindow
              this.iWindow.onPageLoadEnd = window => {
                var editorUI = window.editorUI
                var editor = editorUI.editor
                this.bindWindowFuncs(window)
                if (this.view.viewData) {
                  editor.setDataToGraph(this.view.viewData)
                  editor.undoManager.clear()
                }
              }
            })
          })
        })
    }
  },
  methods: {
    setupIframe() {
      const iframe = this.$refs.iframe;
      if (iframe) {
        this.iWindow = iframe.contentWindow;
        var editorUI = this.iWindow.editorUI
        var editor = editorUI.editor
        this.bindWindowFuncs(this.iWindow)
        if (this.view.viewData) {
          editor.setDataToGraph(this.view.viewData)
          editor.undoManager.clear()
        }
      } else {
        console.warn('Iframe reference not found.');
      }
    },
    initializeEditor() {
    // 确保 editorUI 和 editor 存在且已初始化
    if (this.iWindow && this.iWindow.editorUI) {
      const editorUI = this.iWindow.editorUI;
      const editor = editorUI.editor;

      if (this.view.viewData) {
        editor.setDataToGraph(this.view.viewData);
        editor.undoManager.clear();
      }
    } else {
      console.warn('editorUI or editor not available in the iframe content window.');
    }
  },
    /**
     * 给iframe的window对象绑定方法
     */
    bindWindowFuncs(win) {
      const requestHeaders = {
        Authorization: `Basic ${Base64.encode(`${website.clientId}:${website.clientSecret}`)}`
      }
      const token = getToken();
      if (token) {
        requestHeaders[website.tokenHeader] = 'bearer ' + token
      }
      requestHeaders['Accept-Language'] = sessionStorage.getItem('language') || getPrimaryLanguage() || import.meta.env.VITE_APP_LANGUAGE;
      requestHeaders['Tenat-Id'] = getStore({ name: 'tenantId' }) || '';
      requestHeaders['Blade-Requested-With'] = 'BladeHttpRequest';

      win.parentWindow = {
        imageBaseUrl,
        timeOptions: this.timeOptions,
        compareOptions: this.compareOptions,
        eleJfpgReport: eleJfpgReport,
        jfpgBarGraph,
        // getStationDetail,
        // pickDate: this.pickDate,timeOptions: this.timeOptions,
        // currentArea: this.currentArea,
        stationTreeList: this.stationTreeList,
        viewList: this.viewList,
        saveFile: this.saveGraph,
        // getDeviceList: this.getDeviceList,
        // getDeviceItemInfos,timeOptions
        // getItemInfosByRtuidcbs,
        // getRtDataByItemIds,
        getDSTreeList,
        getDSList,
        getPointList,
        getImageList,
        addImage,
        removeImage,
        requestHeaders,
        getHistoryDataCurve,
        getHistoryDataSum: getCompareTypes, // 对比类型
        // getHistoryDataItemsSum,
        // getAreaInfo,
        getBigScreenInfo, // 尖峰平谷图表数据
        // startVideo,
        sendRequest: request,
        $message: this.$message,
        $notify: this.$message
      }
    },
    /**
     * 保存组态
     */
    saveGraph(data) {
      updatePage({
        ...this.view,
        viewData: data
      }).then(() => {
        this.$message.success(this.Lang.tips.operationSuccess);
        // 通知更新页面
        // return this.$store.dispatch('view/GET_VIEW_LIST')
      })
    },
    /**
     * 获取设备列表，因为用的是分页的接口，所以size传1000
     */
    getDeviceList() {
      const { areaCode, areaRank, parentId } = this.currentArea
      return getDeviceListPage({ areaCode, areaRank, parentId, current: 1, size: 1000 })
    },
    /**
     * 选择日期
     */
    pickDate({ date, dateType }, callback) {
      this.$refs['datePicker'].form.date = date
      this.$refs['datePicker'].form.dateType = dateType
      if (callback) {
        this.dialogCallback = callback
        this.dialogVisible = true
      }
    },
    onChooseDate({ date, dateType }) {
      this.dialogCallback && this.dialogCallback(date, dateType)
    }
  }
}
</script>
<style lang="scss" scoped>
.zutai-editor {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
</style>
